// Janaan Entertainment — shared scripts

// ✏️ Change this to the email address where partner inquiries should go.
const CONTACT_EMAIL = "info@janaanentertainment.com";

// Nav: shrink on scroll + mobile menu
const nav = document.querySelector(".nav");
const onScroll = () => nav && nav.classList.toggle("scrolled", window.scrollY > 40);
window.addEventListener("scroll", onScroll); onScroll();
document.querySelector(".burger")?.addEventListener("click", () => nav.classList.toggle("open"));
document.querySelectorAll(".nav-links a").forEach(a => a.addEventListener("click", () => nav.classList.remove("open")));

// Reveal on scroll
const io = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
}, { threshold: 0.12 });
document.querySelectorAll(".reveal").forEach(el => io.observe(el));

// Animated stat counters
const countIO = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target, target = +el.dataset.count, suffix = el.dataset.suffix || "";
    const start = performance.now(), dur = 1600;
    const tick = t => {
      const p = Math.min((t - start) / dur, 1), eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString() + suffix;
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
    countIO.unobserve(el);
  });
}, { threshold: 0.5 });
document.querySelectorAll("[data-count]").forEach(el => countIO.observe(el));

// Event countdown
document.querySelectorAll(".countdown[data-date]").forEach(cd => {
  const end = new Date(cd.dataset.date).getTime();
  const parts = cd.querySelectorAll("b");
  const update = () => {
    let d = Math.max(0, end - Date.now());
    const vals = [86400000, 3600000, 60000, 1000].map(u => { const v = Math.floor(d / u); d -= v * u; return v; });
    parts.forEach((b, i) => b.textContent = String(vals[i]).padStart(2, "0"));
  };
  update(); setInterval(update, 1000);
});

// Gallery lightbox
const links = [...document.querySelectorAll(".gallery-grid a")];
if (links.length) {
  const lb = document.createElement("div");
  lb.className = "lightbox";
  lb.innerHTML = '<button class="lb-close" aria-label="Close">✕</button><button class="lb-prev" aria-label="Previous">‹</button><img alt=""><button class="lb-next" aria-label="Next">›</button>';
  document.body.appendChild(lb);
  const img = lb.querySelector("img");
  let i = 0;
  const show = n => { i = (n + links.length) % links.length; img.src = links[i].href; };
  links.forEach((a, n) => a.addEventListener("click", e => { e.preventDefault(); show(n); lb.classList.add("on"); }));
  lb.querySelector(".lb-close").onclick = () => lb.classList.remove("on");
  lb.querySelector(".lb-prev").onclick = e => { e.stopPropagation(); show(i - 1); };
  lb.querySelector(".lb-next").onclick = e => { e.stopPropagation(); show(i + 1); };
  lb.addEventListener("click", e => { if (e.target === lb) lb.classList.remove("on"); });
  document.addEventListener("keydown", e => {
    if (!lb.classList.contains("on")) return;
    if (e.key === "Escape") lb.classList.remove("on");
    if (e.key === "ArrowLeft") show(i - 1);
    if (e.key === "ArrowRight") show(i + 1);
  });
}

// Partner form → opens the visitor's email app with everything filled in
document.querySelector("#partner-form-static")?.addEventListener("submit", e => {
  e.preventDefault();
  const f = new FormData(e.target);
  const body = [...f.entries()].map(([k, v]) => `${k}: ${v}`).join("\n");
  const subject = `Partnership Inquiry — ${f.get("Company") || f.get("Name")}`;
  window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
});

// Footer year
document.querySelectorAll(".year").forEach(y => y.textContent = new Date().getFullYear());

// Split the headliner name into letters for the hero animation
let li = 0;
document.querySelectorAll(".show-name .split").forEach(w => {
  w.innerHTML = [...w.textContent].map(c => `<span class="ch" style="--i:${li++}" aria-hidden="true">${c}</span>`).join("");
});

// Load Instagram videos only as they scroll near view (keeps the page fast)
const reelIO = new IntersectionObserver(es => es.forEach(e => {
  if (!e.isIntersecting) return;
  e.target.src = e.target.dataset.src; reelIO.unobserve(e.target);
}), { rootMargin: "400px" });
document.querySelectorAll("iframe[data-src]").forEach(f => reelIO.observe(f));
